import * as React from "react";

type ScrollLogicalPosition = "center" | "end" | "nearest" | "start";

interface IScrollIntoViewOptions {
  block?: ScrollLogicalPosition;
  inline?: ScrollLogicalPosition;
  behavior?: ScrollBehavior;
  top?: number;
}

const useScrollToRef = <T>(
  args?: IScrollIntoViewOptions,
  offset?: number,
): { ref: React.RefObject<T>; executeScroll: () => void } => {
  const ref = React.useRef<T>(null);

  const executeScroll = (): void => {
    // @ts-expect-error replace ts-ignore
    ref.current && ref.current.scrollIntoView(args || {});
    offset && window.scrollBy(0, offset);
  };

  return { ref, executeScroll };
};

export default useScrollToRef;
